import React__default from 'react';
import '../../rev/layouts/Alignment/alignment.scss';
import '../../rev/layouts/Box.js';
import '../../rev/layouts/Group.js';
import '../../rev/layouts/Section.js';
import '../../rev/layouts/Spacing/spacing.scss';
import '../../rev/layouts/Stack.js';
import '../../rev/atoms/Badge.scss';
import 'react-aria-components';
import '../../rev/atoms/Breadcrumbs.scss';
import '../../rev/atoms/Button.js';
import '../../rev/atoms/Callout.scss';
import '../../rev/atoms/Card.scss';
import '../../rev/atoms/Checkbox.js';
import 'lodash';
import '../../rev/atoms/CheckboxGroup.scss';
import '../../rev/atoms/Tag.scss';
import '../../rev/atoms/Chip.scss';
import '../../rev/atoms/DateInput.js';
import '../../rev/atoms/Text.js';
import '../../rev/atoms/Divider.scss';
import '../../rev/atoms/Spinner.scss';
import '../../rev/atoms/Dropzone.scss';
import '../../rev/atoms/Empty.scss';
import 'motion/react';
import '../../rev/molecules/RichDescription.js';
import '../../rev/molecules/TitleGroup.scss';
import '../../rev/atoms/EmptySearchResults.scss';
import 'classnames';
import '../../rev/atoms/Image.scss';
import '@mui/icons-material/EmailOutlined';
import '@mui/icons-material/PhoneOutlined';
import '@mui/icons-material/PlaceOutlined';
import '@mui/icons-material/ScheduleOutlined';
import '../../rev/atoms/LabelledList.scss';
import '../../rev/atoms/LabelPrice.scss';
import '../../rev/atoms/Link.scss';
import '../../rev/atoms/ListViewGroup.scss';
import '../../rev/atoms/ListViewRow.scss';
import '../../rev/atoms/Note.scss';
import '../../rev/atoms/OldTextInput.js';
import '../../rev/atoms/RadioGroup.scss';
import 'framer-motion';
import '../../rev/atoms/SegmentedControl.scss';
import '../../rev/atoms/Skeleton.scss';
import '@mui/icons-material/InfoOutline';
import '../../rev/molecules/Tooltip/Tooltip.js';
import '../../rev/atoms/Slider.scss';
import '../../rev/atoms/SteppedProgressBar.scss';
import '../../rev/atoms/Switch.js';
import '../../rev/atoms/Tabs.scss';
import '../../rev/atoms/TextArea.js';
import '../../rev/atoms/TextInput.js';
import '../../rev/atoms/TimeInput.js';
import '../../rev/atoms/ToggleButton.js';
import '../../rev/atoms/ToggleGroup.js';
import 'react-dom';
import '../../rev/molecules/EmbeddedVideoPlayer/EmbeddedVideoPlayer.scss';
import '../../rev/molecules/Accordion.scss';
import '../../rev/molecules/ActionMenu.scss';
import '../../rev/molecules/BankInfo/BankInfo.scss';
import '../../rev/molecules/Carousel.scss';
import '../../rev/molecules/ContentSlider.js';
import '../../rev/molecules/Drawer.js';
import '../../rev/molecules/Dropdown.scss';
import '../../rev/molecules/Form/index.js';
import '@dnd-kit/core';
import '../../rev/molecules/Kanban/KanbanBoard.scss';
import '../../rev/molecules/Lightbox.scss';
import 'jotai';
import '../../components/loadingAtoms.js';
import '../../rev/molecules/LoadingPage.scss';
import '../../rev/molecules/NavigationMenu.scss';
import '@mui/icons-material/Search';
import 'react-aria';
import 'react-stately';
import 'smartystreets-javascript-sdk';
import 'smartystreets-javascript-sdk-utils';
import '../../utils/addressCache.js';
import '../../rev/molecules/OldAddressInput.scss';
import '../../rev/atoms/Button.scss';
import '../../rev/molecules/OrderFooter.scss';
import '../../rev/molecules/Pagination.scss';
import '../../rev/molecules/Popover.js';
import '../../rev/molecules/Popup.scss';
import '../../rev/molecules/SearchInput.scss';
import '../../rev/molecules/Sheet.js';
import '../../rev/molecules/Table/Table.scss';
import '../../rev/molecules/Toast.js';
import '../../rev/molecules/ToggleCard/ToggleCard.scss';
import '../../rev/molecules/ToggleCard/ToggleCardDescriptionBlock.scss';
import '../../rev/molecules/ToggleCard/ToggleCardGroup.scss';
import '../../rev/molecules/ToggleCard/ToggleCardHeader.scss';
import '../../rev/molecules/ToggleCard/ToggleCardRadioContent.scss';
import { EkhoLogo } from '../../rev/molecules/TopBar.js';
import '@mui/icons-material/Check';
import '../../rev/organisms/ach/ConnectBankAccount.scss';
import '../../rev/organisms/ach/ConnectedBankInfo.scss';
import '../../rev/organisms/AddressInput.js';
import '@react-aria/utils';
import '../../rev/sections/CalculatePaymentModal.scss';
import '../../rev/sections/ConfirmAddressModal.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemAssurance.scss';
import '../../rev/sections/CoverageMenuSection/CoverageItemProductSummary.js';
import '../../rev/sections/CoverageMenuSection/CoverageMenuSection.scss';
import '../../rev/sections/CoverageMenuSection/fixtures/coverageMenuFixtureData.js';
import 'react-hook-form';
import '../../rev/sections/FormModal/schemas.js';
import '@hookform/resolvers/zod';
import '@internationalized/date';
import '../../constants.js';
import '../../rev/sections/FormModal/FormModal.scss';
import '../../rev/sections/FormModal/types.js';
import 'moment';
import '../../types/leads/Lead.js';
import '../../rev/sections/LeadsSection/LeadCard.scss';
import './AuthPageLayout.scss';

const DEFAULT_BANNER_HEADLINE = 'Sell more vehicles. With less work. In every state.';
const DEFAULT_BANNER_DESCRIPTION = "Ekho's vehicle commerce platform unlocks online sales and automates in-store workflows, consolidating your website, F&I, DMV work, taxes, and compliance.";
function RightPanel({ headline, description }) {
    return (React__default.createElement("aside", { className: 'auth-layout__panel-banner', "aria-hidden": 'true' },
        React__default.createElement("video", { className: 'auth-layout__banner-video', autoPlay: true, loop: true, muted: true, playsInline: true },
            React__default.createElement("source", { src: '/assets/vertical-banner.mp4', type: 'video/mp4' })),
        React__default.createElement("div", { className: 'auth-layout__banner-overlay' }),
        React__default.createElement("div", { className: 'auth-layout__banner-content' },
            React__default.createElement("div", { className: 'auth-layout__banner-text' },
                React__default.createElement("h2", { className: 'auth-layout__banner-headline' }, headline ?? DEFAULT_BANNER_HEADLINE),
                React__default.createElement("p", { className: 'auth-layout__banner-description' }, description ?? DEFAULT_BANNER_DESCRIPTION)))));
}
/**
 * AuthPageLayout
 * Shared scaffold for auth/setup/mfa pages:
 * - Left panel: page-specific content (optional Ekho logo and/or custom logo URL)
 * - Right panel: optional static marketing/video content
 * - Optional "Powered by Ekho" footer at bottom center
 */
function AuthPageLayout({ children, showEkhoLogo = true, logoUrl, showRightPanel = true, showPoweredBy = true, contentClassName, bannerHeadline, bannerDescription, }) {
    const showHeader = showEkhoLogo || !!logoUrl;
    return (React__default.createElement("div", { className: 'auth-layout' },
        React__default.createElement("div", { className: 'auth-layout__panel-form' },
            showHeader && (React__default.createElement("header", { className: 'auth-layout__header' },
                logoUrl && (React__default.createElement("img", { src: logoUrl, alt: '', className: 'auth-layout__header-logo' })),
                showEkhoLogo && React__default.createElement(EkhoLogo, null))),
            React__default.createElement("div", { className: `auth-layout__container ${contentClassName ?? ''}`.trim() },
                React__default.createElement("main", { className: 'auth-layout__content' }, children)),
            showPoweredBy && (React__default.createElement("footer", { className: 'auth-layout__footer' },
                React__default.createElement("span", { className: 'auth-layout__footer-text' }, "Powered by"),
                React__default.createElement(EkhoLogo, null)))),
        showRightPanel && (React__default.createElement(RightPanel, { headline: bannerHeadline, description: bannerDescription }))));
}

export { AuthPageLayout };
//# sourceMappingURL=AuthPageLayout.js.map
